import React, { useState, useEffect } from "react";
import "./styles.css";
import { TextField } from "@mui/material";
import { IoClose } from "react-icons/io5";
import ApiServices from "../../services/apiServices";
import Checkbox from "../Checkbox";
import { toast } from "react-toastify";
import Mask from "../../services/mask";
import { useLoad } from "../../context";
const DuploFator = ({ setAbrirDuploFator, setTokenAcesso, setVerificaAntes, setVerificaFechamento}) => {
  const [tipoModal, setTipoModal] = useState(null);
  const [radio, setRadio] = useState("");
  const [codigoRecebido, setCodigoRecebido] = useState("");
  const [codigoOK, setCodigoOK] = useState(true);
  const [smsEmail, setSmsEmail] = useState(null);
  const [eu, setEu] = useState(null);
  const [timeCodigo, setTimeCodigo] = useState(null);
  const { load, setLoad } = useLoad();

  async function fnEu() {
    try {
      setLoad(true);
      let response = await ApiServices.apiGet("eu");
      setEu(response.data);

    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  useEffect(() => {
    fnEu();
  }, []); 

  useEffect(() => {
    if (timeCodigo > 0) {
      const interval = setInterval(() => {
        setTimeCodigo(prevTime => prevTime - 1);
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [timeCodigo]);

  useEffect(()=>{
    if(tipoModal == 2){
      setCodigoOK(null)
    }
  },[tipoModal])

  function fnRadio() {
    if (radio !== "") {
      ApiServices.apiPost("duplo-fator/enviar/" + radio).then((res) => {
        if (res.statusCode === 200) {
          setTimeCodigo(res.data.intervaloEntreSolicitacoesEmSegundos);
          setCodigoOK(true);
          setCodigoRecebido("");
        } else {
          toast.warning(res.message);
        }
        
      });
    }
  }

  useEffect(() => {
    setTipoModal(1);
  }, []);

  useEffect(() => {
    if (tipoModal == 0) {
      setAbrirDuploFator(false);
      setVerificaFechamento(false);
    }
    setRadio("");
  }, [tipoModal]);
  
  useEffect(() => {
    if (tipoModal == 3) {
      setVerificaFechamento(true);
      setVerificaAntes(false);
    }
  }, [tipoModal]);

  return (
    <>
      {tipoModal != 0 && (
        <div className="divModal">
          {tipoModal == 1 && (
            <div className="conteudoModal">
              <div className="tituloModal" style={{ fontWeight: 700 }}>
                {" "}
                <p>CONFIRMAÇÃO DE SEGURANÇA</p>
                <IoClose
                  className="iconeModal"
                  onClick={() => {
                    setTipoModal(0);
                  }}
                />
              </div>

              <div className="textoModal" style={{ textAlign: "center" }}>
               Para seguir com essa transação, enviaremos um código de segurança para confirmar sua identidade.
              </div>

              <button
                className="btn btn-warning my-2"
                onClick={() => {
                  setTipoModal(2);
                }}
              >
                Escolher método de envio
              </button>
              <button
                className=" btn btn-warning my-2"
                onClick={() => {
                  setTipoModal(3);
                }}
              >
                Já tenho um código
              </button>
            </div>
          )}

          {tipoModal == 2 && (
            <div className="conteudoModal">
              <div className="tituloModal" style={{ fontWeight: 700 }}>
                <p>CONFIRMAÇÃO DE SEGURANÇA</p>
                <IoClose
                  className="iconeModal"
                  onClick={() => {
                    setTipoModal(0);
                  }}
                />
              </div>
              <div className="textoModal" style={{ textAlign: "center" }}>
                Escolha o método de envio:
                <div className="radioModalMaisPremios">
                  <div
                    className="d-flex align-items-center "
                    onClick={() => {
                      setRadio("sms");
                      setSmsEmail(false)
                    }}
                  >
                    <Checkbox status={radio == "sms"} />

                    <span style={{ margin: 5 }}>SMS {Mask.cel(eu?.phoneNumber)}</span>
                  </div>
                  <div
                    className="d-flex align-items-center "
                    onClick={() => {
                      setRadio("email");
                      setSmsEmail(true)
                    }}
                  >
                    <Checkbox status={radio == "email"} />

                    <span style={{ margin: 5 }}>E-mail {eu?.email}</span>
                  </div>
                </div>
              </div>
              <button
                className="btn btn-warning my-2"
                disabled={radio == ""}
                onClick={() => {
                  fnRadio();
                  setTipoModal(3);
                  setTimeCodigo(null)
                }}
              >
                Enviar
              </button>
              <span className="mt-2 d-flex justify-content-center" style={{fontSize:"12px"}} >o envio pode acontecer até em 120 segundos</span >
            </div>
          )}
          {tipoModal == 3 && (
            <div className="conteudoModal">
              <div className="tituloModal" style={{ fontWeight: 700 }}>
                <p>VALIDAÇÃO DE SEGURANÇA</p>
                <IoClose
                  className="iconeModal"
                  onClick={() => {
                    setTipoModal(0);
                  }}
                />
              </div>
			  
             {timeCodigo !=  0  && 
             <div className="textoModal">
          
              <div style={{ textAlign: "center" }}>
                Informe o código de segurança no campo abaixo:
                <br />
              </div>
                <div style={{ textAlign: "center" }}>
                <TextField
                  className="inputModal my-3"
                  label="Código"
                  inputProps={{ maxLength: 6, style: { textAlign: "center" } }}
                  value={codigoRecebido}
                  onChange={(e) => {
                    setCodigoRecebido(e.target.value.replace(/\D/g, ""));
                  }}
                />
              </div>
              </div>}
             {timeCodigo == 0 && codigoOK != null && <div className="textoModal" style={{ textAlign: "center" }}> O tempo para a validação do código expirou</div>}
             {timeCodigo !=  0 && <div className="d-flex justify-content-center">
                tempo de recebimento: {timeCodigo ? timeCodigo : 0}
              </div>}
             { timeCodigo != 0 && <button
                className="btn btn-warning my-2"
                onClick={() => {
                  setAbrirDuploFator(false);
                  setTokenAcesso(codigoRecebido);
                  setTipoModal(0);
                }}
              >
                Salvar
              </button>}
              {timeCodigo == 0 &&<button
                className="btn btn-warning my-2"
                onClick={() => {
                  setTipoModal(2);
                }}
              >
                Reenviar código
              </button>}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default DuploFator;
